import tdcpMainSiteApi from "../axios/tdcpMainSiteInstance";

export const fetchServices = async (filters = {}) => {
  const queryParams = new URLSearchParams();

  if (filters.isFeatured !== undefined) {
    queryParams.append("isFeatured", filters.isFeatured);
  }

  if (filters.service_type) {
    queryParams.append("service_type", filters.service_type);
  }

  const url = `/api/get_services?${queryParams.toString()}`;

  const response = await tdcpMainSiteApi.get(url)
  return response.data?.data || []
}

export const createOrUpdateService = async (payload) => {
  try {
    const url = `/api/create_service`;

    const response = await tdcpMainSiteApi.post(url, payload);

    return response.data;
  } catch (error) {
    console.error("Error creating/updating service:", error);
    throw error;
  }
}

export const deleteService = async (serviceId) => {
  try {
    const url = `/api/delete_service/${serviceId}`;
    const response = await tdcpMainSiteApi.delete(url);
    return response.data;
  } catch (error) {
    console.error("Error deleting service:", error);
    throw error;
  }
};

export const fetchAllUsers = async () => {
  const response = await tdcpMainSiteApi.get(`/api/all_users`);
  return response?.data;
}

export const createUser = async (userData) => {
  const response = await tdcpMainSiteApi.post(`/api/create_user`, userData);
  return response?.data;
}

export const updateUser = async (userId, userData) => {
  const response = await tdcpMainSiteApi.put(`/api/update_user/${userId}`, userData);
  return response?.data;
}

export const deleteUser = async (userId) => {
  const response = await tdcpMainSiteApi.delete(`/api/delete_user/${userId}`);
  return response?.data;
}